import { theme } from "../../../../shared/styles/theme.css";
import { figuresGrid, imageContainer } from "./styles.css";

export const CustomDesignCover = () => {
  return (
    <div className={imageContainer}>
      <div className={figuresGrid}>
        <svg
          width="233"
          height="232"
          viewBox="0 0 233 232"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M.5 0v100l72-15V72h88v88h-88v-17l-72 15v74h232V0z"
            fill={theme.colors.grayMedium}
          />
          <path
            d="M72.5 95v38l-72 15v-38l10-2.08z"
            fill={theme.colors.primary}
          />
        </svg>
        <svg
          width="233"
          height="232"
          viewBox="0 0 233 232"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M232.167 0v232H82.207l-3.1-72h81.06V72h-84.86l-3.1-72z"
            fill={theme.colors.grayMedium}
          />
          <path d="M72.167 232h-72V0h62z" fill={theme.colors.primary} />
        </svg>
        <svg
          width="233"
          height="232"
          viewBox="0 0 233 232"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M160.833 130.67h72V232h-232v-72h160zm72-130.67v72h-160v29.32h-72V0z"
            fill={theme.colors.grayMedium}
          />
          <path
            d="M232.833 82v38.67h-82l-6 5.17-28.04 24.16H.833v-38.68h82V111l6-5.12L116.793 82z"
            fill={theme.colors.primary}
          />
        </svg>
        <svg
          width="233"
          height="232"
          viewBox="0 0 233 232"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M.5 0v232h232V0zm160 160h-88V72h88z"
            fill={theme.colors.grayMedium}
          />
          <path
            d="M150.55 82v68.05h-25.73l-8.28-34.04-34.04-6.27V82z"
            fill={theme.colors.primary}
          />
        </svg>
      </div>
    </div>
  );
};
